export enum UserLanguageLevel {
    LANG_LEVEL_1 = 'LANG_LEVEL_1',
	LANG_LEVEL_2 = 'LANG_LEVEL_2',
	LANG_LEVEL_3 = 'LANG_LEVEL_3',
	LANG_LEVEL_4 = 'LANG_LEVEL_4',
	LANG_LEVEL_5 = 'LANG_LEVEL_5'
}
